export default class Image {
    constructor(breakpoints = {
        md: 768,
        xl: 1280
    }) {
        this.breakpoints = breakpoints
        this.bLazy()
        this.renderImage()
        this.ImageScrollLazy()
    }

    bLazy() {
        new Blazy({
            breakpoints: [{
                    width: this.breakpoints.md - 0.02,
                    src: 'data-src-small'
                },
                {
                    width: this.breakpoints.xl - 0.02,
                    src: 'data-src-medium'
                }
            ],
            loadInvisible: true,
            success: function (element) {
                setTimeout(() => {
                    let parent = element.parentNode
                    parent.className = parent.className.replace(/\bloading\b/, '')
                }, 200);
            }
        })
    }

    renderImage() {
        let src = ''
        let img_src = ''
        let $carouselItem = $('.carousel-item')

        this.ImgsrcChange($carouselItem, src, img_src)

        $(window).on('resize', () => {
            this.ImgsrcChange($carouselItem, src, img_src)
        })

    }

    ImgsrcChange($carouselItem, src, img_src) {
        $carouselItem.map((index, item) => {
            src = $(item).data('mb-src')
            if (window.matchMedia(`(min-width:${this.breakpoints.md}px)`).matches &&
                (img_src = $(item).data('tab-src'))) {
                src = img_src
            }
            if (window.matchMedia(`(min-width:${this.breakpoints.xl}px)`).matches &&
                (img_src = $(item).data('pc-src'))) {
                src = img_src
            }
            src && $(item).attr('src', src)
        })
    }

    ImageScrollLazy() {
        let $recommendsList = $('.recommend-list')
        let $Item = $recommendsList.find('.recommend-item')
        let on;
        $recommendsList.on('scroll', () => {
            if (on) return;
            $Item.map((index, el) => {
                let $Img = $(el).find('img')
                if ($Img.data('src')) {
                    $Img.attr('src', $Img.data('src'))
                }
            })
            on = true;
        })

    }
}